import { render, staticRenderFns } from "./RecentChargebacks.vue?vue&type=template&id=81fe0bc0&scoped=true&"
import script from "./RecentChargebacks.vue?vue&type=script&lang=js&"
export * from "./RecentChargebacks.vue?vue&type=script&lang=js&"
import style0 from "./RecentChargebacks.vue?vue&type=style&index=0&id=81fe0bc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81fe0bc0",
  null
  
)

export default component.exports